import ErrorBoundary from 'reporting-action-components/utils/ErrorBoundary';
import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { SRVDatasetTableConfigReport } from './SRVDatasetTableConfigReport';
import { SRVDatasetTableSnowflakeReport } from './SRVDatasetTableSnowflakeReport';
import { jsx as _jsx } from "react/jsx-runtime";
export function SRVDatasetTable({
  previewReport,
  suppressActionsBar
}) {
  if (isConfigReport(previewReport)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(SRVDatasetTableConfigReport, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      })
    });
  }
  if (isRelationalReport(previewReport)) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(SRVDatasetTableSnowflakeReport, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      })
    });
  }
  return null;
}